import { IconNameV1 } from 'common/icon/iconV1.js';
import { WarningSeverity } from 'utilities/weather-warnings/warning-severity.js';

export interface IInlineWarningProps {
  warnLevel: WarningSeverity;
  label: string;
  icon?: IconNameV1;
  url?: string;
}

export const ICON_MODIFIERS: Partial<Record<WarningSeverity, string>> = {
  [WarningSeverity.Red]: 'warning-general-tri-red',
  [WarningSeverity.Yellow]: 'warning-general-cir-yellow',
  [WarningSeverity.Orange]: 'warning-general-hex-orange',
};
